<template>
  <div class="group-order-summary">
    <div class="group-order-selections-wrapper">
      <div v-if="!loadStatus">
        <Skeleton
          width="80%"
          height="3.5rem"
          v-for="i in 15"
          :key="i"
          color="#E3E3E3"
          :style="{ 'margin-left': 'auto', 'margin-right': 'auto' }"
        />
      </div>
      <div class="current-redemption-items" v-if="loadStatus">
        <!-- Products here -->
        <!-- <h5>Products</h5> -->
        <SummaryAccordion :columns="columns" :rowItems="accordionRowItems" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SummaryAccordion from './SummaryAccordion.vue'
import { progressStatus } from '../../helpers'

export default {
  name: 'GroupOrderSummaryTab',
  props: {
    groupOrderId: {
      type: Number,
      required: true
    },

    groupOrderDetails: {
      type: Object,
      required: true,
      default: () => {}
    }
  },

  data() {
    return {
      columns: [
        {
          label: 'Product',
          width: '20%',
          textAlign: 'left'
        },
        {
          label: 'Product Name',
          width: '45%',
          textAlign: 'left'
        },
        {
          label: 'Redeemed',
          width: '30%',
          textAlign: 'center'
        }
      ]
    }
  },

  components: {
    SummaryAccordion,
    Skeleton: () => import('@/components/Universal/Skeleton')
  },
  created() {
    this.$store.dispatch(
      'groupOrder/getGroupOrderOrderedItems',
      this.groupOrderId
    )
  },
  computed: {
    loadStatus() {
      return progressStatus(this.loadGroupOrderItemsOrdered)
    },
    accordionRowItems() {
      return this.groupOrderItemsOrdered
    },
    ...mapState({
      loadGroupOrderItemsOrdered: state =>
        state.groupOrder.loadGroupOrderItemsOrdered,
      groupOrderItemsOrdered: state => state.groupOrder.groupOrderItemsOrdered
    })
  },

  methods: {
    doCopy() {
      this.$copyText(this.groupOrderDetails.recipientCollectionPaigeUrl).then(
        () => {
          this.$store.dispatch('notification/pushNotification', {
            type: 'success',
            messages: [`Redemption page link copied`]
          })
        },
        error => {
          this.$store.dispatch('notification/pushNotification', {
            type: 'error',
            messages: [`Can not copy redemption page link.`]
          })
          console.log(error)
        }
      )
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.group-order-selections-wrapper {
  padding: 1.75rem;
  background: inherit;
  border: 1px solid #000;
  border-radius: 29px;
}

.product-in-tiers {
  margin-bottom: 3rem;

  h5 {
    text-align: left;
    margin-bottom: 2rem;
  }

  .product-list {
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
  }

  .product {
    height: 160px;
    width: 160px;
    overflow: hidden;
    display: block;

    .product-image {
      width: 70%;
      margin: 0 auto;
    }

    .product-image img {
      width: 100%;
      object-fit: contain;
    }

    .product-content {
      height: 60px;
      padding: 10px;
      p {
        font-size: 12px;
      }
    }
  }
}

.current-redemption-items {
  h5 {
    text-align: left;
    margin-bottom: 1.5rem;
    font-size: $content-font-size;
  }

  .product-icon {
    width: 60px;
  }

  .variant-name {
    p {
      font-weight: 600;
    }

    span {
      font-size: 14px;
      text-transform: capitalize;
      opacity: 0.5;
    }
  }
}

@media (max-width: 860px) {
  .group-order-selections-wrapper {
    padding: 1rem;
  }
}

.page-link-content {
  display: flex;
  align-items: baseline;
  grid-gap: 2rem;
  margin-bottom: 48px;

  @media (max-width: 1100px) {
    align-items: flex-end;
  }

  .link-holder {
    display: flex;
    align-items: center;
    width: 85%;
    height: 53px;
    border: 1px solid $main-6;
    color: $main-6;

    span {
      padding: 1.5rem;
      min-width: 50px;
      word-break: break-all;
      font-size: $content-font-size;
    }

    .ml-auto {
      background: white;
      border: 1px solid $main-6;
      border-right: none;
      margin-left: auto;
      padding: 1rem;
      height: inherit;
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    @media (max-width: 1100px) {
      flex-wrap: wrap;
      width: 100%;
      height: auto;

      span {
        padding: 0.5rem;
      }

      .ml-auto {
        display: none;
      }
    }
  }
}

@media (max-width: 630px) {
  .group-order-summary {
    padding-bottom: 10rem;
  }
}
</style>
